// src/components/ScrollDownButtonZeroCoin.jsx

import { motion } from "framer-motion";
import PropTypes from "prop-types";
import { forwardRef } from "react";
import { TiArrowDown } from "react-icons/ti";

const ScrollDownButtonZeroCoin = forwardRef(({ targetId, onClick, additionalClasses }, ref) => {
  const handleClick = () => {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <div className="fixed bottom-10 left-0 right-0 flex justify-center z-50">
      <motion.div
        ref={ref}
        className={`flex items-center gap-3 px-5 py-3 bg-black/40 backdrop-blur-sm border border-cyan-500/30 rounded-full shadow-lg shadow-cyan-500/10 cursor-pointer hover:bg-black/60 hover:border-cyan-400/50 transition-all duration-500 ${additionalClasses}`}
        onClick={handleClick}
        role="button"
        aria-label="Scroll down to content"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleClick();
          }
        }}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut", delay: 0.5 }}
      >
        <motion.div
          animate={{ y: [0, 5, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        >
          <TiArrowDown
            className="text-cyan-400 transition-all duration-500"
            size={24}
          />
        </motion.div>
        <span className="relative z-20 text-sm uppercase text-white/80 font-medium tracking-wider transition-colors duration-500 hover:text-white">
          SCROLL DOWN
        </span>
      </motion.div>
    </div>
  );
});

ScrollDownButtonZeroCoin.propTypes = {
  targetId: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  additionalClasses: PropTypes.string,
};

ScrollDownButtonZeroCoin.defaultProps = {
  onClick: () => {},
  additionalClasses: "",
};

export default ScrollDownButtonZeroCoin;
